// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"09ac27de","977":"07232d49"}[chunkId] + ".chunk.js";
};